import { Grid } from '@mui/material'
import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../../store'
import { useSelector } from 'react-redux'
import RecentProjectComponent from './RecentProjectComponent'

interface RecentProjectsProps {}

const userRecentFilesSelector = createSelector(
  [(state: RootState) => state.organization],
  (organization) => organization.userRecentFiles,
)
const projectsSelector = createSelector(
  [(state: RootState) => state.organization],
  (organization) => organization.projects,
)
const selectedProjectSelector = createSelector(
  [(state: RootState) => state.organization],
  (organization) => organization.selectedProject,
)

const RecentProjectsComponent: React.FC<RecentProjectsProps> = ({}) => {
  const useRecentFiles = useSelector(userRecentFilesSelector)
  const projects = useSelector(projectsSelector)
  const selectedProject = useSelector(selectedProjectSelector)

  const uniqueProjectFiles = []
  const projectIds = new Set()

  for (const recentFile of useRecentFiles) {
    const project = projects.find(
      (project) => project.id === recentFile.file.project_id,
    )

    if (project && !projectIds.has(recentFile.file.project_id)) {
      uniqueProjectFiles.push(recentFile)
      projectIds.add(recentFile.file.project_id)
    }

    if (uniqueProjectFiles.length === 3) {
      break
    }
  }

  return (
    <Grid container spacing='1rem'>
      {uniqueProjectFiles.map((recentFile) => {
        const project = projects.find(
          (project) => project.id === recentFile.file.project_id,
        )
        return (
          <Grid
            size={4}
            key={recentFile.id}
            sx={{
              boxSizing: 'border-box',
              boxShadow: '0px 2px 10px 0px #0000001A',
              padding: '0.75rem',
              border:
                !!project && selectedProject?.id === project.id
                  ? '2px solid #1705E5'
                  : '2px solid transparent',
              borderRadius: '0.4rem',
              '&:hover': {
                border: '2px solid #1705E5',
              },
            }}
          >
            {project && <RecentProjectComponent project={project} />}
          </Grid>
        )
      })}
    </Grid>
  )
}

export default RecentProjectsComponent
